import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from './../../../environments/environment';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../cfet-core';

@Component({
    selector: 'app-cancel-modal',
    templateUrl: './cancel-modal.component.html',
    styleUrls: ['./cancel-modal.component.scss'],
    standalone: false
})
export class CancelModalComponent extends CfetBaseComponent {

  @Input() openModal: string;
  @Output() closeModal = new EventEmitter<any>();
  @Output() setNewSession = new EventEmitter<any>();

  constructor() { super(); }


  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
    }
  }

  cancelApplication(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this[modalAction] = 'close';
      this.closeModal.emit('modalClose');
      const url = environment.getBrowserPath() + CfetPageNamesConstant.CUSTOMER_LANDING;
      this.redirectUrl(url);
      this.setNewSession.emit(true);
      sessionStorage.clear();
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

}
